import React, { useState } from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { DocsBitText, DocsIllustration, DocsTable, DocsTd, DocsTr } from 'apps/auth/components/common/components/DocsList/styles';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const OfakimDocsInfo = (props) => {
    const { profile_form: profileForm } = useExtra();
    const {
        aml_level_name,
        amlLimitDocs1,
        amlLimitDocs3,
        chat_limits_title,
        chat_limits_preview,
        chatTitle,
        continueButton,
        docs_limits_title,
        docsOr,
        increase_block,
        increase_sub_block,
        notNowButton,
        profilePurpleBlock,
        wait_limits_title,
        wait_limits_preview,
    } = usePageMessages();
    const [isInfoScreen, setInfoScreen] = useState(true);

    return (
        <ModalComponent
            isVerticalCentered
            canCloseModal={!isInfoScreen}
            modalRef={props.modalRef}
            isIconClose={false}
            onCloseIconClick={(e) => {
                e.preventDefault();
                if (!isInfoScreen) {
                    setInfoScreen(true);
                }
            }}
        >
            {isInfoScreen && (
                <InfoPage
                    insideModalComponent={true}
                    iconName="id-card-80"
                    iconColor="primary"
                    headerText={
                        <>
                            <span className="color-GT">{resolveArguments(profilePurpleBlock, aml_level_name)}</span>&nbsp;
                            {increase_block}
                        </>
                    }
                    secondaryText={<DangerouslyHtml dangerouslyHtml={increase_sub_block} />}
                    topButtonCaption={notNowButton}
                    topButtonOnClick={() => props.modalRef.current?.close()}
                    primaryButtonCaption={continueButton}
                    primaryButtonType="button"
                    primaryButtonOnClick={() => setInfoScreen(false)}
                />
            )}
            {!isInfoScreen && (
                <>
                    <DocsList>
                        <DocsListItem title={docs_limits_title}>
                            <DocsTable>
                                <DocsTr>
                                    <DocsTd>
                                        <DocsIllustration>
                                            <img src={`${URL_IMAGES_I}/kyc-passport.svg`} alt="passport" />
                                        </DocsIllustration>
                                        <DocsBitText>{docsOr}</DocsBitText>
                                    </DocsTd>
                                    <DocsTd>
                                        <DocsIllustration>
                                            <img src={`${URL_IMAGES_I}/kyc-id-card.svg`} alt="idcard" />
                                        </DocsIllustration>
                                    </DocsTd>
                                </DocsTr>
                                <DocsTr>
                                    <DocsTd>
                                        <Text variant={'paragraph'} indent={'16px'}>
                                            {amlLimitDocs1}
                                        </Text>
                                    </DocsTd>
                                    <DocsTd>
                                        <Text variant={'paragraph'} indent={'16px'}>
                                            {amlLimitDocs3}
                                        </Text>
                                    </DocsTd>
                                </DocsTr>
                            </DocsTable>
                        </DocsListItem>
                        <DocsListItem title={chat_limits_title}>
                            <p>{resolveArguments(chat_limits_preview, profileForm?.id)}</p>
                        </DocsListItem>
                        <DocsListItem title={wait_limits_title}>
                            <p>{wait_limits_preview}</p>
                        </DocsListItem>
                    </DocsList>
                    <FixedBottomPanel isRightAligned>
                        <Button onClick={() => props.toggleChat(true)} raised={true} size="fit" caption={chatTitle} />
                    </FixedBottomPanel>
                </>
            )}
        </ModalComponent>
    );
};
export default connect(null, { toggleChat })(OfakimDocsInfo);
